export const authStatuses = {
  unknown: 'unknown',
  unauthorized: 'unauthorized',
  authorized: 'authorized',
};
